export const PERMISSION_RESOURCE_CODES = {
  dashboard: 'greenplant-dashboard',
  assets: 'greenplant-assets',
  tasks: 'greenplant-tasks',
  issues: 'greenplant-issues',
  insights: 'greenplant-insights',
  settings: 'greenplant-settings',
  dataScopes: 'greenplant-data-scopes',
} as const;

export const PERMISSION_ACTION_CODES = {
  dashboard: {},
  assets: {
    create: 'create',
    update: 'update',
    remove: 'remove',
  },
  tasks: {
    create: 'create',
    execute: 'execute',
    defer: 'defer',
  },
  issues: {
    create: 'create',
    assign: 'assign',
    resolve: 'resolve',
    close: 'close',
    reopen: 'reopen',
  },
  insights: {},
  settings: {
    manage: 'manage',
  },
  dataScopes: {
    manage: 'manage',
  },
} as const;

export const permissionKey = (
  resource: (typeof PERMISSION_RESOURCE_CODES)[keyof typeof PERMISSION_RESOURCE_CODES],
  action?: string,
) => (action ? `${resource}:${action}` : resource);

export const GREENPLANT_PERMISSION_RESOURCES = [
  {
    name: '绿植工作台',
    code: PERMISSION_RESOURCE_CODES.dashboard,
    type: 'MENU',
    description: '查看待办、风险和运营概览',
    actions: [],
  },
  {
    name: '绿植台账',
    code: PERMISSION_RESOURCE_CODES.assets,
    type: 'MENU',
    description: '管理绿植点位对象和台账信息',
    actions: [
      {
        name: PERMISSION_ACTION_CODES.assets.create,
        description: '新建绿植点位对象',
      },
      {
        name: PERMISSION_ACTION_CODES.assets.update,
        description: '维护绿植点位对象',
      },
      {
        name: PERMISSION_ACTION_CODES.assets.remove,
        description: '移除绿植点位对象',
      },
    ],
  },
  {
    name: '养护任务',
    code: PERMISSION_RESOURCE_CODES.tasks,
    type: 'MENU',
    description: '查看、安排和执行养护任务',
    actions: [
      {
        name: PERMISSION_ACTION_CODES.tasks.create,
        description: '创建或调整任务',
      },
      {
        name: PERMISSION_ACTION_CODES.tasks.execute,
        description: '提交养护结果',
      },
      { name: PERMISSION_ACTION_CODES.tasks.defer, description: '延期任务' },
    ],
  },
  {
    name: '异常处理',
    code: PERMISSION_RESOURCE_CODES.issues,
    type: 'MENU',
    description: '上报、分派、处置和关闭异常',
    actions: [
      { name: PERMISSION_ACTION_CODES.issues.create, description: '上报异常' },
      { name: PERMISSION_ACTION_CODES.issues.assign, description: '分派异常' },
      {
        name: PERMISSION_ACTION_CODES.issues.resolve,
        description: '追加处理结果',
      },
      { name: PERMISSION_ACTION_CODES.issues.close, description: '关闭异常' },
      {
        name: PERMISSION_ACTION_CODES.issues.reopen,
        description: '重新打开异常',
      },
    ],
  },
  {
    name: '运营洞察',
    code: PERMISSION_RESOURCE_CODES.insights,
    type: 'MENU',
    description: '查看运营统计与风险下钻',
    actions: [],
  },
  {
    name: '配置中心',
    code: PERMISSION_RESOURCE_CODES.settings,
    type: 'MENU',
    description: '维护模板、字典、通知规则和区域授权',
    actions: [
      {
        name: PERMISSION_ACTION_CODES.settings.manage,
        description: '保存业务配置',
      },
    ],
  },
  {
    name: '数据范围授权',
    code: PERMISSION_RESOURCE_CODES.dataScopes,
    type: 'MENU',
    description: '在企业管理的权限资源中维护绿植人员和组织的数据访问范围',
    actions: [
      {
        name: PERMISSION_ACTION_CODES.dataScopes.manage,
        description: '授予、调整和撤销绿植数据范围',
      },
    ],
  },
] as const;

export const GREENPLANT_PERMISSION_IMPORT_PAYLOAD = {
  resources: GREENPLANT_PERMISSION_RESOURCES,
} as const;
